(function () {
  function getAccordionItems(root) {
    return Array.prototype.filter.call(root.querySelectorAll('details'), function (item) {
      return item.closest('[data-close-others]') === root;
    });
  }

  function initCloseOthersGroup(root) {
    if (!root || root.dataset.closeOthersReady === 'true') return;

    root.dataset.closeOthersReady = 'true';

    root.addEventListener('click', function (event) {
      var details = event.target.closest('details');
      if (!details || details.closest('[data-close-others]') !== root) return;
      if (!event.target.closest('summary')) return;
      if (!details.open) return;

      var items = getAccordionItems(root);
      for (var i = 0; i < items.length; i++) {
        if (items[i] !== details) {
          items[i].open = false;
        }
      }
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-close-others]');
    for (var i = 0; i < roots.length; i++) {
      initCloseOthersGroup(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    var roots = event.target.querySelectorAll('[data-close-others]');
    for (var i = 0; i < roots.length; i++) {
      delete roots[i].dataset.closeOthersReady;
    }

    initAll(event.target);
  });
})();
